import React from 'react';
import logo from '../assets/zizi-pickleball-logo.png';
import SocialBar from './SocialBar';
import { useTranslation } from 'react-i18next';
const UpArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#5ec6fd" viewBox="0 0 16 16"><path fillRule="evenodd" d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"/><path fillRule="evenodd" d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/></svg>
);


const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="main-footer">
      <SocialBar></SocialBar>
      <div className="footer-content">
        <div className="footer-logo">
            <img src={logo} alt="Zizi Pickleball Logo" />
        </div>
        <div className="info-column">
          <p className="footer-heading">{t('footer.address')}</p>
          <p>
            <a href="https://www.google.com/maps/place/Pickleball+Split+klub+Zizi/@43.5183799,16.4930102,19z/data=!3m1!4b1!4m6!3m5!1s0x13355f34830c8585:0xa1b59fbf5ed3042d!8m2!3d43.5183789!4d16.4936539!16s%2Fg%2F11xp200yv0?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
              Pickleball Split klub Zizi,<br/>Lovrinačka 63,<br/>Split
            </a>
          </p>
        </div>
        <div className="info-column">
          <p className="footer-heading">{t('footer.contactUs')}</p>
          <p>
            <a href="mailto:info@zizipickleball.hr">
              info@zizipickleball.hr
            </a>
            <br/>
            <a href="tel:+385913782937" aria-label="Call +385 91 378 2937">
                +385 91 378 2937
            </a>
          </p>
          <p>
            <a href="https://chat.whatsapp.com/DhjdBxSDOP4BwuSrc5vGq6?mode=ac_t">{t('footer.joinCommunity')}</a>
          </p>
        </div>
        <div className="info-column">
          <p className="footer-heading">{t('footer.workingHours')}</p>
          <p>{t('footer.hours')}</p>
        </div>
      </div>
      <a href="#top" className="back-to-top" aria-label={t('footer.backToTop')}><UpArrowIcon /></a>
    </footer>
  );
};

export default Footer;